import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer id="footer" className="bg-brand-blue text-white pt-16 pb-8 md:pt-20 md:pb-10" data-id="element-48">
      <div className="container mx-auto px-4 md:px-6" data-id="element-49">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16" data-id="element-50">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-1 space-y-6" data-id="element-51">
            <div className="flex items-center" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/pkXGAPQ966SzyjEPMbYQGj/ChatGPT_Image_Jun_24,_2026,_08_19_22_PM.png" alt="MediRide USA Logo" className="h-24 md:h-32 w-auto object-contain bg-white rounded-2xl p-2" data-id="element-53" />
            </div>
            <p className="text-blue-100 leading-relaxed" data-id="element-54">
              Providing professional, compassionate non-emergency medical
              transportation services across the region.
            </p>
            <div className="flex gap-4" data-id="element-55">
              {[{
              Icon: Facebook,
              label: 'Facebook'
            }, {
              Icon: Twitter,
              label: 'Twitter'
            }, {
              Icon: Linkedin,
              label: 'LinkedIn'
            }, {
              Icon: Instagram,
              label: 'Instagram'
            }].map(({
              Icon,
              label
            }, i) => <a key={i} href="#" className="w-10 h-10 rounded-full border border-blue-400 flex items-center justify-center hover:bg-white hover:text-[#002D72] transition-all focus-visible:ring-2 focus-visible:ring-white outline-none" aria-label={`Follow us on ${label}`} data-id="element-56">
                  <Icon size={20} aria-hidden="true" data-id="element-57" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Footer Quick Links" className="col-span-1" data-id="element-58">
            <h4 className="text-lg md:text-xl font-bold mb-4 md:mb-6" data-id="element-59">
              Quick Links
            </h4>
            <ul className="space-y-3 md:space-y-4 text-sm md:text-base text-blue-100" data-id="element-60">
              {[{
              name: 'About Us',
              path: '/about'
            }, {
              name: 'Services',
              path: '/services'
            }, {
              name: 'Employees',
              path: '/employees'
            }, {
              name: 'FAQ',
              path: '/faq'
            }, {
              name: 'Careers',
              path: '/employees'
            }, {
              name: 'Pay Now',
              path: '#'
            }].map(link => <li key={link.name} data-id="element-61">
                  <Link to={link.path} className="hover:text-white transition-colors focus-visible:underline outline-none" aria-label={`Go to ${link.name}`} data-id="element-62">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </nav>

          {/* Services */}
          <div className="col-span-1" data-id="element-63">
            <h4 className="text-lg md:text-xl font-bold mb-4 md:mb-6" data-id="element-64">
              Our Services
            </h4>
            <ul className="space-y-3 md:space-y-4 text-sm md:text-base text-blue-100" data-id="element-65">
              {['Stretcher Transport', 'Wheelchair Transport', 'Ambulatory Transport', 'Bariatric Transport', 'Long Distance'].map(service => <li key={service} data-id="element-66">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-67">
                    {service}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 lg:col-span-1" data-id="element-68">
            <h4 className="text-lg md:text-xl font-bold mb-4 md:mb-6" data-id="element-69">
              Contact Us
            </h4>
            <ul className="space-y-4 md:space-y-6 text-sm md:text-base text-blue-100" data-id="element-70">
              <li className="flex gap-4" data-id="element-71">
                <Phone className="shrink-0 text-blue-300" data-id="element-72" />
                <span data-id="element-73">(555) 123-4567</span>
              </li>
              <li className="flex gap-4" data-id="element-74">
                <Mail className="shrink-0 text-blue-300" data-id="element-75" />
                <span data-id="element-76">info@carebridge.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-10 border-t border-blue-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-blue-300" data-id="element-77">
          <p data-id="element-78">
            © {new Date().getFullYear()} MediRide USA. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-79">
            <a href="#" className="hover:text-white" data-id="element-80">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-81">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}